// Core
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

// Chakra imports
import { Box } from '@chakra-ui/react';

// Components
import ApiKey from './ApiKey';
import ApiKeysEdit from './ApiKeysEdit';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

function ApiKeys(props) {
  const { path } = useRouteMatch();

  const isApiKeys = usePermissionStatusByKey('GET:/admin/api-keys');
  const isCreateApiKey = usePermissionStatusByKey('POST:/admin/api-keys');
  const isPartners = usePermissionStatusByKey('GET:/admin/partners');

  return (
    <>
      <Box>
        <Switch>
          {isPartners && isCreateApiKey && (
            <Route
              path={`${path}/:id(new|\\d+)`}
              render={() => <ApiKeysEdit />}
            />
          )}

          {(isApiKeys || isCreateApiKey) && (
            <Route path={`${path}`} render={() => <ApiKey />} />
          )}
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default ApiKeys;
